import { render } from "./portprojects.vue?vue&type=template&id=1fa63fc4"
import script from "./portprojects.vue?vue&type=script&lang=js"
export * from "./portprojects.vue?vue&type=script&lang=js"

import "./portprojects.vue?vue&type=style&index=0&id=1fa63fc4&lang=scss"

import exportComponent from "C:\\laragon\\www\\juani\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__